import { createSelector } from '@ngrx/store';

import { surveyCreationFeature } from '../survey-creation.feature';

const { selectReference } = surveyCreationFeature;

export const selectQualificationsRecord = createSelector(
  selectReference,
  ({ qualificationsRecord }) => qualificationsRecord,
);

export const selectQuestionCategories = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.data,
);

export const selectQuestionCategoriesCachedAt = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.cachedAt,
);

export const selectIsQuestionCategoriesLoading = createSelector(
  selectReference,
  ({ questionCategories }) => questionCategories.loading,
);

export const selectQuestionsRecord = createSelector(
  selectReference,
  ({ questionsRecord }) => questionsRecord,
);

export const selectQuestionsLoadingKey = createSelector(
  selectReference,
  ({ questionsLoadingKey }) => questionsLoadingKey,
);

export const selectLocationConditionsRecord = createSelector(
  selectReference,
  ({ locationConditionsRecord }) => locationConditionsRecord,
);

export const selectLocationConditionsLoadingKey = createSelector(
  selectReference,
  ({ locationConditionsLoadingKey }) => locationConditionsLoadingKey,
);
